var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-dialog',{attrs:{"name":"terms_of_service"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('title')))]),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('terms-of-service')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }